<template>
	<div class="journeys-skew-banner">
		<div class="container">
			<BackButton
				black-arrow
				@back-click="handleBackButton"
				class="arrow-btn arrow-btn-back--grey top"
			/>
			<div class="row">
				<div class="col journeys-skew-banner__content text-center">
					<h1 class="h2">{{ microcopy?.heading }}</h1>
					<p>{{ microcopy?.summary }}</p>
				</div>
			</div>
		</div>
	</div>
	<div class="container pull-up">
		<form class="w-100" @submit.prevent>
			<div class="rounded-container rounded-container--narrow">
				<div class="row flex-column">
					<div class="col rounded-container__btn-col">
						<TextInputField
							required
							:manual-input-dirtier="buttonClicked"
							input-type="currency"
							:label-text="microcopy?.costOfPropertyInputLabel"
							:error-text="microcopy?.costOfPropertyInputError"
							:prefill-input="propertyValueMounted"
							@field-input="(payload) => {
								postPropertyValue(payload.value)
								inputValue.propertyValue = payload.value;
								isValid.propertyValue = payload.isValid;
							}"
						>
							<template #tooltip>
								<Tooltip :content="microcopy.costOfPropertyInputTooltip" />
							</template>
						</TextInputField>

						<TextInputField
							required
							input-type="currency"
							:manual-input-dirtier="buttonClicked"
							:label-text="microcopy?.depositInputLabel"
							:error-text="microcopy?.depositInputError"
							:prefill-input="depositMounted"
							@field-input="(payload) => {
								postDeposit(payload.value)
								inputValue.depositAmount = payload.value;
								isValid.depositAmount = payload.isValid;
							}"
						>
							<template v-slot:tooltip>
								<Tooltip :content="microcopy.depositInputTooltip" />
							</template>
						</TextInputField>
					</div>
					<div class="col rounded-container__btn-col">
						<GenericButton
							:label-text="microcopy?.nextButtonLabel"
							@button-click="handleClick"
						/>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import TextInputField from '@/shared/components/TextInputField.vue';
import GenericButton from '@/shared/components/GenericButton.vue';
import BackButton from '@/shared/components/BackButton.vue';
import Tooltip from '@/shared/components/Tooltip.vue';

import router from '../router/index.js';

import { mapStores, mapActions, mapState } from 'pinia';
import { useMortgageStore } from '../stores/mortgageStore.js';

export default {
	components: {
		TextInputField,
		GenericButton,
		BackButton,
		Tooltip
	},
	data() {
		return {
			microcopy: window.mortgageRequestMicrocopy.propertyDetails,
			propertyValueMounted: '',
			depositMounted: '',
			isValid: {
				propertyValue: false,
				depositAmount: false,
			},
			inputValue: {
				propertyValue: '',
				depositAmount: '',
			},
			buttonClicked: false,
		};
	},
	computed: {
		...mapStores(useMortgageStore),
		...mapState(useMortgageStore, ['propertyValue', 'deposit']),
		buttonDisabled() {
			return Object.values(this.isValid).includes(false);
		},
		allValid() {
			return Object.values(this.isValid).every(Boolean);
		}
	},
	methods: {
		...mapActions(useMortgageStore, ['postPropertyValue', 'postDeposit']),
		handleBackButton() {
			router.back();
		},
		handleClick() {
			this.buttonClicked = true;

			if (!this.allValid) {
				return;
			}

			scrollTo({ top: 0, behavior: 'smooth' });
			router.push('your-details');
		},
	},
	mounted() {
		if (this.propertyValue) {
			this.propertyValueMounted = this.propertyValue;
			this.isValid.propertyValue = true;
		}
		if (this.deposit) {
			this.depositMounted = this.deposit;
			this.isValid.depositAmount = true;
		}

		document.title = this.microcopy?.metaTitle
	}
};
</script>
